import React, { ReactNode } from 'react';
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
  useTheme,
} from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';
import { stepperStyles } from '../../styles';

interface InfoCardProps {
  title: string;
  icon?: SvgIconComponent;
  description?: string;
  items?: string[];
  showItemTypography?: boolean;
  children?: ReactNode;
  elevation?: number;
  showDivider?: boolean;
}

const InfoCard: React.FC<InfoCardProps> = ({
  title,
  icon: Icon,
  description,
  items,
  showItemTypography = true,
  children,
  elevation = 2,
  showDivider = false,
}) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={3}
      sx={{
        flex: 1,
        ...stepperStyles.elevatedCard(theme),
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        {Icon && <Icon sx={{ fontSize: 32, color: 'primary.main', mr: 1 }} />}
        <Typography variant="h5" gutterBottom={showDivider}>
          {title}
        </Typography>
      </Box>
      {showDivider && <Divider sx={{ mb: 3 }} />}
      {description && (
        <Typography variant="body2" sx={{ mb: 0 }}>
          {description}
        </Typography>
      )}
      {items && (
        <List dense sx={{ listStyleType: 'disc', pl: 2 }}>
          {items.map((item, index) => (
            <ListItem key={index} sx={{ px: 0, py: 0, display: 'list-item' }}>
              <ListItemText
                primary={item}
                primaryTypographyProps={
                  showItemTypography ? { variant: 'body2' } : undefined
                }
              />
            </ListItem>
          ))}
        </List>
      )}
      {children}
    </Paper>
  );
};

export default InfoCard;
